var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex flex-col accordion-item",
      staticStyle: { overflow: "hidden" },
    },
    [
      _c("scheduler-item-row", {
        attrs: {
          backGroundColor: "",
          weekDates: _vm.weekDates,
          quarterMonths: _vm.quarterMonths,
          weeks: _vm.weeks,
          isDays: _vm.isDays,
          isMonths: _vm.isMonths,
          isWeeks: _vm.isWeeks,
          columnSpan: _vm.columnSpan,
        },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("employee-item", {
                  attrs: {
                    isManager: false,
                    manager: _vm.contractor.manager,
                    projects: _vm.contractor.projects,
                    contractors: _vm.contractor.contractors,
                    projectsInprogress: _vm.projectsInprogress,
                    color: _vm.color,
                    projectsCompleted: _vm.completedProjects,
                    isOpened: _vm.isOpened,
                    item: _vm.contractor,
                    isInner: false,
                    filterBy: "maganer",
                  },
                  on: { toggleCollapse: _vm.toggleCollapse },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "progress",
            fn: function () {
              return [_c("circle-progress-item", { attrs: { hasData: false } })]
            },
            proxy: true,
          },
          {
            key: "progressBar",
            fn: function () {
              return [
                _c("progress-item", {
                  attrs: {
                    item: _vm.contractor,
                    color: _vm.color,
                    progress: _vm.getContractorProgressWidth,
                    width: _vm.contractorProgressWidth,
                    marginLeft: _vm.getLeftMargin,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isOpened
        ? [
            _vm._l(_vm.contractor.projects, function (project) {
              return [
                _vm.contractor.projects.length > 0
                  ? _c("scheduler-item-row", {
                      staticClass: "text-base font-semibold",
                      attrs: {
                        backGroundColor: "rgba(2, 163, 218, 0.1)",
                        weekDates: _vm.weekDates,
                        quarterMonths: _vm.quarterMonths,
                        weeks: _vm.weeks,
                        isDays: _vm.isDays,
                        isMonths: _vm.isMonths,
                        isWeeks: _vm.isWeeks,
                        columnSpan: _vm.columnSpan,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function () {
                              return [
                                _c("project-item", {
                                  attrs: {
                                    isOpened: _vm.isOpened,
                                    item: project,
                                    isInner: true,
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "progress",
                            fn: function () {
                              return [
                                _c("circle-progress-item", {
                                  attrs: { hasData: false },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "progressBar",
                            fn: function () {
                              return [
                                _c("progress-item", {
                                  attrs: {
                                    item: project,
                                    color: _vm.color,
                                    progress:
                                      _vm.getProjectProgressWidth(project),
                                    width:
                                      _vm.getProjectProgressItemWidth(project),
                                    marginLeft:
                                      _vm.getProjectLeftMargin(project),
                                    type: "project",
                                    currentUser: _vm.currentUser,
                                    companyId: _vm.companyId,
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                _vm._l(project.activities, function (activity, index) {
                  return project.activities.length > 0
                    ? _c("scheduler-item-row", {
                        key: activity.id,
                        staticClass: "text-base",
                        attrs: {
                          backGroundColor: "#F2F2F2",
                          weekDates: _vm.weekDates,
                          quarterMonths: _vm.quarterMonths,
                          weeks: _vm.weeks,
                          isDays: _vm.isDays,
                          isMonths: _vm.isMonths,
                          isWeeks: _vm.isWeeks,
                          columnSpan: _vm.columnSpan,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "left",
                              fn: function () {
                                return [
                                  _c("activity-item", {
                                    attrs: {
                                      item: activity,
                                      index: index,
                                      color: _vm.color,
                                      currentUser: _vm.currentUser,
                                      companyId: _vm.companyId,
                                      project: project,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "progress",
                              fn: function () {
                                return [
                                  _c(
                                    "circle-progress-item",
                                    {
                                      attrs: {
                                        hasData: true,
                                        item: project,
                                        color: _vm.color,
                                        completed:
                                          _vm.getActivityCompletedSteps(
                                            activity
                                          ),
                                        total: 10,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "inner-text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getActivityPercentageComplete(
                                                activity
                                              )
                                            ) + "%"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "progressBar",
                              fn: function () {
                                return [
                                  _c("progress-item", {
                                    attrs: {
                                      item: activity,
                                      color: _vm.color,
                                      progress:
                                        _vm.getActivityProgressWidth(activity),
                                      width:
                                        _vm.getActivityProgressitemWith(
                                          activity
                                        ),
                                      marginLeft:
                                        _vm.getActivityLeftMargin(activity),
                                      type: "activity",
                                      currentUser: _vm.currentUser,
                                      companyId: _vm.companyId,
                                      project: project,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e()
                }),
                _c("scheduler-item-row", {
                  attrs: {
                    backGroundColor: "#F2F2F2",
                    weekDates: _vm.weekDates,
                    quarterMonths: _vm.quarterMonths,
                    weeks: _vm.weeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function () {
                          return [
                            _c("add-activity-item", {
                              attrs: {
                                type: "activity",
                                message: "Add Task",
                                currentUser: _vm.currentUser,
                                companyId: _vm.companyId,
                                project: project,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "progress",
                        fn: function () {
                          return [
                            _c("circle-progress-item", {
                              attrs: { hasData: false },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            }),
            _vm.contractor.projects.length <= 0
              ? _c("scheduler-item-row", {
                  attrs: {
                    backGroundColor: "#F2F2F2",
                    weekDates: _vm.weekDates,
                    quarterMonths: _vm.quarterMonths,
                    weeks: _vm.weeks,
                    isDays: _vm.isDays,
                    isMonths: _vm.isMonths,
                    isWeeks: _vm.isWeeks,
                    columnSpan: _vm.columnSpan,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "left",
                        fn: function () {
                          return [
                            _c("add-activity-item", {
                              attrs: {
                                type: "project",
                                message: "Add Project",
                                currentUser: _vm.currentUser,
                                companyId: _vm.companyId,
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "progress",
                        fn: function () {
                          return [
                            _c("circle-progress-item", {
                              attrs: { hasData: false },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4108072319
                  ),
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }